import React, { useState } from 'react';
import './DropdownMenu.scss';
import { CustomIcon, Icon, Typography } from '@design-system';
import { VscChevronRight } from 'react-icons/vsc';
import { useNavigate } from 'react-router-dom';

export type DropdownMenuProps = {
    title: string;
    icon: string | React.FC<React.SVGProps<SVGSVGElement>>;
    variant: 'red' | 'blue' | 'yellow';
    items: {
        title: string;
        icon: React.ReactNode;
        link: string;
    }[];
} & React.HTMLAttributes<HTMLDivElement>;

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ title, icon, variant, items, ...props }) => {
    const [isOpened, setIsOpened] = useState<boolean>(false);

    const handleToggle = () => {
        setIsOpened(!isOpened);
    };

    const navigate = useNavigate();

    return (
        <div className="dropdown-menu" data-variant={variant} {...props}>
            <div className="header" data-opened={isOpened} onClick={handleToggle}>
                <div className="header-content">
                    <CustomIcon src={icon} alt={title} />
                    <Typography intrinsic="h3">{title}</Typography>
                </div>

                <div className="header-indicator" data-opened={isOpened}>
                    <VscChevronRight strokeWidth={0.4} />
                </div>
            </div>

            <div className="content" data-opened={isOpened}>
                {items.map((item) => (
                    <div className="content-item" key={item.title} onClick={() => navigate(item.link)}>
                        <Icon icon={item.icon} size={20} color={variant} variant="surrounded" />
                        <Typography intrinsic="h4">{item.title}</Typography>
                    </div>
                ))}
            </div>
        </div>
    );
};
